import { DiamondNode, DiamondNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class ExclusiveGatewayView extends DiamondNode {
  getShape() {
    const { model } = this.props;
    const { x, y, rx, ry } = model;
    void model.properties.__tv; // MobX: re-render on theme change
    const style = model.getNodeStyle();
    const points = `${x},${y - ry} ${x + rx},${y} ${x},${y + ry} ${x - rx},${y}`;

    return h('g', {}, [
      h('polygon', {
        points,
        ...style,
      }),
      // X marker (BPMN standard for Exclusive Gateway)
      h('path', {
        d: `M ${x - 8} ${y - 8} L ${x + 8} ${y + 8} M ${x + 8} ${y - 8} L ${x - 8} ${y + 8}`,
        stroke: style.stroke,
        strokeWidth: 2.5,
        fill: 'none',
      }),
    ]);
  }
}

class ExclusiveGatewayModel extends DiamondNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 30;
    this.ry = 30;
    initLabelOffset(this, data, this.ry + 18);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'exclusiveGateway');
    style.stroke = t.stroke || '#faad14';
    style.strokeWidth = t.strokeWidth ?? 2;
    style.fill = t.fill || '#fffbe6';
    return style;
  }
}

export const ExclusiveGateway = {
  type: 'epx:ExclusiveGateway',
  view: ExclusiveGatewayView,
  model: ExclusiveGatewayModel,
};
